import Vue from 'vue'
import VueRouter from 'vue-router'

//引入页面文件
// import Overview from '@/views/overview/index.vue'

import Home from '@/views/home/index.vue'
import Article from '@/views/article/index.vue'
import ArticleDetail from '@/views/article/detail.vue'
import SingleImage from '@/views/single-image/index.vue'
import ImageText from '@/views/image-text/index.vue'
import TextList from '@/views/text-list/index.vue'
import TabList from '@/views/tab-list/index.vue'
import CoopPartner from '@/views/coop-partner/index.vue'
import ContactUs from '@/views/contact-us/index.vue'
import SearchResult from '@/views/searchPage/searchResult.vue'
import SearchDetail from '@/views/searchPage/detail.vue'
import Introduction from '@/views/base/introduction/index.vue'
import Project from '@/views/base/project/index.vue'
import ProjectDetail from '@/views/base/project/detail.vue'
import Faculty from '@/views/base/faculty/index.vue'
import Collaboration from '@/views/collaboration/index.vue'
import Course from '@/views/base/course/index.vue'
import CourseDetail from '@/views/base/course/detail.vue'

import Train from '@/train/home/index.vue'
import Article_2 from '@/train/article/index.vue'
import ArticleDetail_2 from '@/train/article/detail.vue'
import SingleImage_2 from '@/train/single-image/index.vue'
import ImageText_2 from '@/train/image-text/index.vue'
import TextList_2 from '@/train/text-list/index.vue'
import TabList_2 from '@/train/tab-list/index.vue'
import CoopPartner_2 from '@/train/coop-partner/index.vue'
import ContactUs_2 from '@/train/contact-us/index.vue'
import SearchResult_2 from '@/train/searchPage/searchResult.vue'
import SearchDetail_2 from '@/train/searchPage/detail.vue'
import Layout from '@/layout/index.vue'
Vue.use(VueRouter)

//添加以下代码
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

const routes = [
  // 首页
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    meta: {
      title: '福建通文产业服务有限公司',
      breadcrumb: '首页'
    },
    children: [
      {
        path: '/home',
        name: 'Home',
        component: Home,
        meta: {
          title: '福建通文产业服务有限公司 - 首页',
          content: {
            keywords: '福建通文产业服务有限公司,首页,高质量就业服务,产教融合,人力资源产业园运营',
            description: '福建通文产业服务有限公司（通文服务）提供首页服务。围绕政府、高校、企业、人才，助力高质量就业与产业发展。'
          },
          breadcrumb: '',
          requiresAuth: false,
          type: '101'
        }
      },
      {
        path: '/article',
        name: 'Article',
        component: Article,
        meta: {
          title: '福建通文产业服务有限公司 - 文章中心',
          content: {
            keywords: '福建通文产业服务有限公司,文章中心,新闻资讯,行业动态,高质量就业服务',
            description: '福建通文产业服务有限公司（通文服务）提供文章中心服务。围绕政府、高校、企业、人才，助力高质量就业与产业发展。'
          },
          breadcrumb: '',
          requiresAuth: false,
          type: '102'
        }
      },
      {
        path: '/imageText',
        name: 'ImageText',
        component: ImageText,
        meta: {
          title: '福建通文产业服务有限公司 - 图文资讯',
          content: {
            keywords: '福建通文产业服务有限公司,图文资讯,新闻动态,产业服务,高质量就业服务',
            description: '福建通文产业服务有限公司（通文服务）提供图文资讯服务。围绕政府、高校、企业、人才，助力高质量就业与产业发展。'
          },
          breadcrumb: '',
          requiresAuth: false,
          type: '103'
        }
      },
      {
        path: '/tabList',
        name: 'TabList',
        component: TabList,
        meta: {
          title: '福建通文产业服务有限公司 - 标签列表',
          content: {
            keywords: '福建通文产业服务有限公司,标签列表,分类信息,产业服务,高质量就业服务',
            description: '福建通文产业服务有限公司（通文服务）提供标签列表服务。围绕政府、高校、企业、人才，助力高质量就业与产业发展。'
          },
          breadcrumb: '',
          requiresAuth: false,
          type: '104',
          keepAlive: false
        }
      },
      {
        path: '/articleDetail',
        name: 'ArticleDetail',
        component: ArticleDetail,
        meta: {
          title: '福建通文产业服务有限公司 - 文章详情',
          content: {
            keywords: '福建通文产业服务有限公司,文章详情,新闻资讯,产业服务,高质量就业服务',
            description: '福建通文产业服务有限公司（通文服务）提供文章详情服务。围绕政府、高校、企业、人才，助力高质量就业与产业发展。'
          },
          breadcrumb: '',
          requiresAuth: false,
          type: '103'
        }
      },
      {
        path: '/searchPage/searchResult',
        name: 'SearchResult',
        component: SearchResult,
        meta: {
          title: '福建通文产业服务有限公司 - 搜索结果',
          content: {
            keywords: '福建通文产业服务有限公司,搜索结果,信息查询,产业服务,高质量就业服务',
            description: '福建通文产业服务有限公司（通文服务）提供搜索结果服务。围绕政府、高校、企业、人才，助力高质量就业与产业发展。'
          },
          breadcrumb: '搜索结果'
        }
      },
      {
        path: '/searchPage/searchDetail',
        name: 'SearchDetail',
        component: SearchDetail,
        meta: {
          title: '福建通文产业服务有限公司 - 搜索详情',
          content: {
            keywords: '福建通文产业服务有限公司,搜索详情,信息详情,产业服务,高质量就业服务',
            description: '福建通文产业服务有限公司（通文服务）提供搜索详情服务。围绕政府、高校、企业、人才，助力高质量就业与产业发展。'
          },
          breadcrumb: '文章详情'
        }
      },
      {
        path: '/base/introduction',
        name: 'Base-Introduction',
        component: Introduction,
        meta: {
          title: '实训基地',
          breadcrumb: '',
          requiresAuth: false,
          type: '201'
        }
      },
      {
        path: '/base/project',
        name: 'Base-Project',
        component: Project,
        meta: {
          title: '实训项目',
          breadcrumb: '',
          requiresAuth: false,
          type: '201'
        }
      },
      {
        path: '/base/project/detail',
        name: 'Base-Project-Detail',
        component: ProjectDetail,
        meta: {
          title: '实训项目详情',
          breadcrumb: '',
          requiresAuth: false,
          type: '201'
        }
      },
      {
        path: '/base/faculty',
        name: 'Base-Faculty',
        component: Faculty,
        meta: {
          title: '师资队伍',
          breadcrumb: '',
          requiresAuth: false,
          type: '201'
        }
      },
      {
        path: '/base/course',
        name: 'Base-Course',
        component: Course,
        meta: {
          title: '线上课程',
          breadcrumb: '',
          requiresAuth: false,
          type: '201'
        }
      },
      {
        path: '/base/course/detail',
        name: 'Base-Course-Detail',
        component: CourseDetail,
        meta: {
          title: '线上课程详情',
          breadcrumb: '',
          requiresAuth: false,
          type: '201'
        }
      },
      {
        path: '/collaboration',
        name: 'Collaboration',
        component: Collaboration,
        meta: {
          title: '协同育人',
          breadcrumb: '',
          requiresAuth: false,
          type: '203'
        }
      }
    ]
  },

  {
    path: '/singleImage',
    name: 'SingleImage',
    component: SingleImage,
    meta: {
      title: '福建通文产业服务有限公司 - 单图展示',
      content: {
        keywords: '福建通文产业服务有限公司,单图展示,图片资讯,产业服务,高质量就业服务',
        description: '福建通文产业服务有限公司（通文服务）提供单图展示服务。围绕政府、高校、企业、人才，助力高质量就业与产业发展。'
      },
      breadcrumb: '',
      requiresAuth: false
    }
  },

  {
    path: '/textList',
    name: 'TextList',
    component: TextList,
    meta: {
      title: '福建通文产业服务有限公司 - 文本列表',
      content: {
        keywords: '福建通文产业服务有限公司,文本列表,文字资讯,产业服务,高质量就业服务',
        description: '福建通文产业服务有限公司（通文服务）提供文本列表服务。围绕政府、高校、企业、人才，助力高质量就业与产业发展。'
      },
      breadcrumb: '',
      requiresAuth: false
    }
  },

  {
    path: '/coopPartner',
    name: 'CoopPartner',
    component: CoopPartner,
    meta: {
      title: '福建通文产业服务有限公司 - 合作伙伴',
      content: {
        keywords: '福建通文产业服务有限公司,合作伙伴,合作企业,产业服务,高质量就业服务',
        description: '福建通文产业服务有限公司（通文服务）提供合作伙伴服务。围绕政府、高校、企业、人才，助力高质量就业与产业发展。'
      },
      breadcrumb: '',
      requiresAuth: false
    }
  },
  {
    path: '/contactUs',
    name: 'ContactUs',
    component: ContactUs,
    meta: {
      title: '福建通文产业服务有限公司 - 联系我们',
      content: {
        keywords: '福建通文产业服务有限公司,联系我们,联系方式,产业服务,高质量就业服务',
        description: '福建通文产业服务有限公司（通文服务）提供联系我们服务。围绕政府、高校、企业、人才，助力高质量就业与产业发展。'
      },
      breadcrumb: '',
      requiresAuth: false
    }
  },

  {
    path: '/train',
    name: 'Train',
    component: Train,
    meta: {
      title: '福建通文产业服务有限公司 - 高质量就业服务 | 产教融合 | 人力资源产业园运营',
      content: {
        keywords: '福建通文产业服务有限公司,高质量就业服务,产教融合,人力资源产业园运营,福建人才服务，集美区公共实训基地',
        description: '福建通文服务，以“产业数字化、服务智能化”为引擎，围绕政府、高校、企业、人才提供园区运营、产教融合、技能提升、就业服务、企业服务等八大体系，致力高质量就业服务，服务人才成长，赋能产业发展。'
      },
      breadcrumb: '首页'
    }
  },
  {
    path: '/train/article',
    name: 'Article_2',
    component: Article_2,
    meta: {
      title: '福建通文产业服务有限公司 - 培训文章',
      content: {
        keywords: '福建通文产业服务有限公司,培训文章,培训资讯,技能提升,高质量就业服务',
        description: '福建通文产业服务有限公司（通文服务）提供培训文章服务。围绕政府、高校、企业、人才，助力高质量就业与产业发展。'
      },
      breadcrumb: '',
      requiresAuth: false
    }
  },
  {
    path: '/train/articleDetail',
    name: 'ArticleDetail_2',
    component: ArticleDetail_2,
    meta: {
      title: '福建通文产业服务有限公司 - 培训文章详情',
      content: {
        keywords: '福建通文产业服务有限公司,培训文章详情,培训资讯,技能提升,高质量就业服务',
        description: '福建通文产业服务有限公司（通文服务）提供培训文章详情服务。围绕政府、高校、企业、人才，助力高质量就业与产业发展。'
      },
      breadcrumb: '',
      requiresAuth: false
    }
  },
  {
    path: '/train/singleImage',
    name: 'SingleImage_2',
    component: SingleImage_2,
    meta: {
      title: '福建通文产业服务有限公司 - 培训单图展示',
      content: {
        keywords: '福建通文产业服务有限公司,培训单图展示,培训图片,技能提升,高质量就业服务',
        description: '福建通文产业服务有限公司（通文服务）提供培训单图展示服务。围绕政府、高校、企业、人才，助力高质量就业与产业发展。'
      },
      breadcrumb: '',
      requiresAuth: false
    }
  },
  {
    path: '/train/imageText',
    name: 'ImageText_2',
    component: ImageText_2,
    meta: {
      title: '福建通文产业服务有限公司 - 培训图文资讯',
      content: {
        keywords: '福建通文产业服务有限公司,培训图文资讯,培训动态,技能提升,高质量就业服务',
        description: '福建通文产业服务有限公司（通文服务）提供培训图文资讯服务。围绕政府、高校、企业、人才，助力高质量就业与产业发展。'
      },
      breadcrumb: '',
      requiresAuth: false
    }
  },
  {
    path: '/train/textList',
    name: 'TextList_2',
    component: TextList_2,
    meta: {
      title: '福建通文产业服务有限公司 - 培训文本列表',
      content: {
        keywords: '福建通文产业服务有限公司,培训文本列表,培训文字资讯,技能提升,高质量就业服务',
        description: '福建通文产业服务有限公司（通文服务）提供培训文本列表服务。围绕政府、高校、企业、人才，助力高质量就业与产业发展。'
      },
      breadcrumb: '',
      requiresAuth: false
    }
  },
  {
    path: '/train/tabList',
    name: 'TabList_2',
    component: TabList_2,
    meta: {
      title: '福建通文产业服务有限公司 - 培训标签列表',
      content: {
        keywords: '福建通文产业服务有限公司,培训标签列表,培训分类,技能提升,高质量就业服务',
        description: '福建通文产业服务有限公司（通文服务）提供培训标签列表服务。围绕政府、高校、企业、人才，助力高质量就业与产业发展。'
      },
      breadcrumb: '',
      requiresAuth: false
    }
  },
  {
    path: '/train/coopPartner',
    name: 'CoopPartner_2',
    component: CoopPartner_2,
    meta: {
      title: '福建通文产业服务有限公司 - 培训合作伙伴',
      content: {
        keywords: '福建通文产业服务有限公司,培训合作伙伴,合作机构,技能提升,高质量就业服务',
        description: '福建通文产业服务有限公司（通文服务）提供培训合作伙伴服务。围绕政府、高校、企业、人才，助力高质量就业与产业发展。'
      },
      breadcrumb: '',
      requiresAuth: false
    }
  },
  {
    path: '/train/contactUs',
    name: 'ContactUs_2',
    component: ContactUs_2,
    meta: {
      title: '福建通文产业服务有限公司 - 培训联系我们',
      content: {
        keywords: '福建通文产业服务有限公司,培训联系我们,培训联系方式,技能提升,高质量就业服务',
        description: '福建通文产业服务有限公司（通文服务）提供培训联系我们服务。围绕政府、高校、企业、人才，助力高质量就业与产业发展。'
      },
      breadcrumb: '',
      requiresAuth: false
    }
  },
  {
    path: '/train/searchPage/searchResult',
    name: 'SearchResult_2',
    component: SearchResult_2,
    meta: {
      title: '福建通文产业服务有限公司 - 培训搜索结果',
      content: {
        keywords: '福建通文产业服务有限公司,培训搜索结果,培训信息查询,技能提升,高质量就业服务',
        description: '福建通文产业服务有限公司（通文服务）提供培训搜索结果服务。围绕政府、高校、企业、人才，助力高质量就业与产业发展。'
      },
      breadcrumb: '搜索结果'
    }
  },
  {
    path: '/train/searchPage/searchDetail',
    name: 'SearchDetail_2',
    component: SearchDetail_2,
    meta: {
      title: '福建通文产业服务有限公司 - 培训搜索详情',
      content: {
        keywords: '福建通文产业服务有限公司,培训搜索详情,培训信息详情,技能提升,高质量就业服务',
        description: '福建通文产业服务有限公司（通文服务）提供培训搜索详情服务。围绕政府、高校、企业、人才，助力高质量就业与产业发展。'
      },
      breadcrumb: '文章详情'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition // 恢复滚动位置（浏览器后退时）
    } else {
      return { x: 0, y: 0 } // 跳转到新页面时滚动到顶部
    }
  }
})

// router.beforeEach(function (to, from, next) {
//   let flag = navigator.userAgent.match(
//     /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
//   )
//   if (flag) {
//     console.log(flag)
//     // 如果是移动端设备，重定向到移动端首页
// window.location.href = 'https://mobile.fjtwfw.com/home'
//   } else {
//     next() //继续往后走
//   }
// })

// 路由守卫，动态设置页面meta信息
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // 设置 meta 标签
  if (to.meta.content) {
    Object.keys(to.meta.content).forEach(key => {
      const metaTag = document.querySelector(`meta[name="${key}"]`)
      if (metaTag) {
        metaTag.setAttribute('content', to.meta.content[key])
      }
    })
  }
  next()
})

export default router
